module.exports = __webpack_public_path__ + "media/images/help/line/heading-merit-5da8f40ce174638c76d3fb3386e0136f.svg";